const CategoryFilter = ({ categories, selectedCategory, setSelectedCategory, styles, theme, children }) => {
  return (
    <div style={styles.card1}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
        <div style={styles.categoryFilter}>
          {categories.map((category) => {
            const CategoryIcon = category.icon;
            const isActive = selectedCategory === category.id;

            return (
              <div
                key={category.id}
                style={styles.categoryItem(isActive)}
                onClick={() => setSelectedCategory(category.id)}
               >
                <CategoryIcon size={20} />
                {category.name}
              </div>
            );
          })}
        </div>
        {children}
      </div>
    </div>
  );
};

export default CategoryFilter;